﻿var vm;
var vm1;
var vm2;
var dataselectors;
var listActionType;
var listOperationType;
var lastIdAppointment;
//Visualizacion del listado de Eir
(function () {

    'use strict';
    var controllerId = 'eirSearchMainCtrl';
    angular
        .module('app.controllers')
        .controller(controllerId, eirSearchMainCtrl);

    eirSearchMainCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$translate', '$timeout', '$state', '$element', '$sce', '$window', '$stateParams', 'vsblockui', '$compile'];

    function eirSearchMainCtrl(common, datacontext, $http, $scope, $translate, $timeout, $state, $element, $sce, $window, $stateParams, vsblockui, $compile) {
        vm = this;
        vm.display = false;
        vm.showData = false;
        vm.showDataNot = false;
        vm.showDataError = false;
        vm.showLoading = false;
        /*---paginación----*/
        vm.total = 0;
        vm.countPartial = 10;
        vm.initialposition = 1;

        /*----------------*/
        vm.test = ':D';
        vm.actionTypeList = {};
        vm.action = ['GTO', 'GTI'];
        vm.equipmentSelected = {};
        vm.eirSelected = {};
        vm.vesselSelected = {};
        vm.voyageSelected = {};
        vm.eirList = [];
        vm.dataResult = { totalCount: 0 };
        vm.varequipmentlist = [];
        vm.yardsList = {};
        vm.operationTypeList = {};
        vm.varstatus = {};
        vm.varyard = {};
        vm.varaction = {};
        //functions
        vm.getEirList = getEirList;
        vm.clickActionType = clickActionType;
        vm.voyageNumber = null;
        vm.varactiontype = "";
        vm.nro_registros = 0;
        vm.displayInfoNoData = true;
        var lbl_All = $translate.instant('views.eir.all');

        vm.pageSize = '500';
        vm.TruckerBPRoleCode = "TRU";
        vm.ShipperBPRoleCode = "SHI";

        vm.clear = function () {
            $scope.$broadcast('angucomplete-alt:clearInput');
            vm.equipmentNo = null;
            vm.eirNo = null;
            vm.vesselSelected.originalObject = undefined;
            vm.voyageSelected.originalObject = undefined;
            vm.eirList = [];
            vm.countPartial = 10;
            vm.initialposition = 1;
            vm.total = 0;
            vm.dataResult = { totalCount: 0 };
            vm.voyageNumber = null;
            vm.displayInfoNoData = true;
        }

        vm.showPrintGTOView = function () {
            var url = $state.href('root.eirGTOPrint', { });
            window.open(url, '_blank');
        }

        init();

        function init() {
            common.activateController([getStatusByLanguage(), getActionTypes()])
                .then(function (data) {
                });
        }

        function getActionTypes() {
            return datacontext.appointment.getFilters().then(function (data) {
                data.ActionTypes.splice(0, 0, { ActionTypeId: 0, Name: lbl_All, isactive: 1 });
                listActionType = vm.actionTypeList = data.ActionTypes;
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getStatusByLanguage() {
            return datacontext.appointment.getFilters().then(function (data) {
                if (data) {
                    data.AppointmentStatuses.splice(0, 0, { EntityStatusTypeId: 0, Name: lbl_All, isactive: 1 });
                    vm.varstatus = data.AppointmentStatuses[0].EntityStatusTypeId;
                }

            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }
        vm.selectedEquipmentFn = function (selected) {

            if (selected != undefined) {
                vm.equipmentSelected = selected;
                vm.getEirList();
            }
            else {
                vm.equipmentSelected.originalObject = undefined;
            }
        }

        vm.selectedEirFn = function (selected) {

            if (selected != undefined) {
                vm.eirSelected = selected;
                vm.getEirList();
            }
            else {
                vm.eirSelected.originalObject = undefined
            }
        }

        vm.selectedVesselFn = function (selected) {
            if (selected != undefined) {
                vm.vesselSelected = selected;
                vm.getEirList();
            }
            else {
                vm.vesselSelected.originalObject = undefined;
            }
        }

        vm.selectedVoyageFn = function (selected) {
            if (selected != undefined) {
                vm.voyageSelected = selected;
                vm.getEirList();
            }
        }

        vm.getEquipmentsByNo = function (criteria) {

            return datacontext.eir.getEquipmentsByNo(criteria);
        };

        vm.getEirByNo = function (criteria) {

            return datacontext.eir.getEirByNo(criteria);
        };

        vm.getVesselByName = function (criteria) {
            return datacontext.eir.getVesselByName(criteria);
        };

        vm.getVoyageByNo = function (criteria) {
            return datacontext.eir.getVoyageByNo(criteria);
        };

        vm.eirList = vm.eirList;

        function clickActionType(item) {
            var el = angular.element(document.querySelector('.active.action'));
            el.removeClass('active action');
            var selector = "";
            if (item.currentTarget.attributes['actiontypeid'].value == "ALL") {
                selector = "";
            }
            if (item.currentTarget.attributes['actiontypeid'].value == "P") {
                selector = "GTO";
            }
            if (item.currentTarget.attributes['actiontypeid'].value == "D") {
                selector = "GTI";
            }
            vm.varactiontype = selector;
            this.getEirList();
        }

        function showModalApptView(appointmentId) {
            vm1.showModalApptView(appointmentId);
        }

        function setEmpty(val) {
            if (val == 0 || val == "0" || val == "T")
                val = "";
            return val;
        }

        vm.equipmentNo = null;
        vm.eirNo = null;
        vm.languageId = 0;
        function getEirList() {
            var authData = common.localStorageService.get('authorizationData');
            var roletype = authData ? authData.userRole : "";
            var eqpNo = vm.equipmentNo !== null ? vm.equipmentNo.trim() : "";
            var eirNo = vm.eirNo !== null ? vm.eirNo.trim() : "";

            if (roletype == vm.TruckerBPRoleCode && eqpNo == "" && eirNo == "") {
                toastr.error($translate.instant('views.eir.ValidateEquipmentOrEir'));
                return;
            }
            var isShipper = (roletype === "Appointment" || roletype === vm.ShipperBPRoleCode) ? true : false;
            if (isShipper && eqpNo == "" && eirNo == "") {
                toastr.error($translate.instant('views.eir.ValidateEquipmentOrEir'));
                return;
            }

            vm.display = true;
            vm.showLoading = true;
            vm.showData = false;
            vm.total = 0;
            vm.displayInfoNoData = false;
            vsblockui.enable();

            var model = {
                EquipmentNo: vm.equipmentNo,
                EIRNo: vm.eirNo,
                VesselName: null,
                VoyageNumber: vm.voyageNumber,
                EirId: null,
                EquipmentId: null,
                VesselId: angular.isUndefined(vm.vesselSelected.originalObject) ? null : vm.vesselSelected.originalObject.VesselId,
                VoyageId: angular.isUndefined(vm.voyageSelected.originalObject) ? null : vm.voyageSelected.originalObject.VoyageId,
                code: setEmpty(vm.varactiontype),
                actualposition: parseInt(vm.initialposition),
                countPartial: parseInt(vm.countPartial),
                UserRole: roletype,
                IsOnlyPortalUser : authData ? authData.isOnlyPortalUser : false
            }

            return datacontext.eir.getEIRByEqIdEirIdVesselIdVoyageId(model).then(function (data) {
                vm.dataResult = data;
                if (data.success) {
                    vm.eirList = data.data;
                    vm.languageId = data.languageId;
                    vm.nro_registros = vm.dataResult.totalCount;
                    vm.total = vm.dataResult.totalCount;
                    vm.showData = data.data.length > 0;
                    vm.showDataNot = data.data.length == 0;
                    vm.showDataError = false;
                    vm.showLoading = false;
                    if (data.data.length == 0)
                        vm.displayInfoNoData = true;
                }
                else {
                    vm.showData = false;
                    vm.showLoading = false;
                    vm.showDataNot = false;
                    vm.showDataError = true;
                    vm.displayInfoNoData = true;
                    if (data.error) {
                        alertify.error(data.error);
                    }
                }
                if (!vm.nro_registros > 0)
                    vm.nro_registros = 0;
                vm.display = false;
                vsblockui.enable();
            }, function (err) {
                console.log(err);
                vm.showData = false;
                vm.showDataNot = false;
                vm.showLoading = false;
                vm.showDataError = true;
                vm.displayInfoNoData = true;
                if (err.status)
                    toastr.error(err.info);
            });
            //}
        }

        function scrollToTarget(idAppointment) {
            var selector = '[aid=' + idAppointment + ']';
            var fromContainerPos = $(selector).position().top;
            var fromTopPagePos = $(selector).offset().top;
            $('#resultsContainer').animate({
                scrollTop: $('#resultsContainer').scrollTop() + fromContainerPos
            }, 500);
            $(".appt-equ-popup").hide();
            $(".appt-equ-popup").fadeIn(1400);
        }

        vm.LanguageId = 0;
        vm.getLanguageId = function () {
            return datacontext.eir.getLanguageId({}).then(function (data) {
                vm.LanguageId = data;
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        };
        vm.getLanguageId();

        vm.urlLogoOrganization = '';
        vm.getLogoByOrganizationCode = function () {
            return datacontext.eir.getOrganizationLogoUrl({}).then(function (data) {

                vm.urlLogoOrganization = data;
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        vm.getLogoByOrganizationCode();

        vm.showPrintApptView = function (id, eirNo,actionCode) {
            if(actionCode == "GTI"){
                var url = $state.href('eirReport', { EIRId: id, EIRNo: eirNo, LanguageId: vm.LanguageId, UrlLogoOrganization: vm.urlLogoOrganization });
                window.open(url, '_blank');
            }
            else{
                var url = $state.href('root.eirGTOPrint', {EIRId: id});
                window.open(url, '_blank');
            }
        }

        vm.enterSearch = function ($event) {
            if ($event.keyCode == "13") {
                vm.getEirList();
            }
        };
    }
})();
